import StoreController from '@projeccions-pdc/frontend-storage';
import AppContext from '../../AppContext';
import AppController from '../../AppController';
import localizedStrings from '../Localization/localization';
import { Auth } from 'aws-amplify';

class AuthController {
    static changePassword = (oldPassword, newPassword, notify) => {
        return Auth.currentAuthenticatedUser()
            .then((user) => {
                return Auth.changePassword(user, oldPassword, newPassword);
            })
            .then((response) => {
                notify('info', localizedStrings.passwordChanged);
                return response;
            })
            .catch((err) => {
                console.log(err);
                notify('error', localizedStrings.errorChangePassword);
            });
    };

    static signOut = (history) => {
        return Auth.signOut()
            .then((data) => {
                // console.log(data);
                new StoreController('', '').set('isUserInit', undefined);
                return AuthController.refreshSession().then(() => {
                    // Reload page to force clean data
                    if (Object.keys(localStorage).some((e) => e.indexOf('Cognito') !== -1) === false) {
                        window.location.href = '/';
                    }
                    history.push('/login');
                });
            })
            .catch((err) => {
                console.log(err);
            });
    };

    static getSession = () => {
        return Auth.currentSession()
            .then((session) => {
                // console.log('session', session)
                return Promise.resolve(session);
            })
            .catch((err) => {
                console.log(err);
                return Promise.resolve(undefined);
            });
    };

    static refreshSession = (history) => {
        return AuthController.getSession().then((session) => {
            return AuthController.setSession(session, history);
        });
    };

    static refreshAuthenticatedUser = () => {
        return Auth.currentAuthenticatedUser({ bypassCache: true }).then((a) => console.log('AAA', a));
    };

    // https://github.com/aws-amplify/amplify-js/issues/4396
    // static async refreshSessionPromise(refreshToken) {
    //     return new Promise(async (resolve, reject) => {
    //         const user = await Auth.currentAuthenticatedUser();
    //         return user.refreshSession(refreshToken, async (err, data) => {
    //             if (err) {
    //                 reject(err);
    //             } else {
    //                 resolve(data); // THIS IS YOUR REFRESHED ATTRIBUTES/GROUPS
    //             }
    //         });
    //     });
    // }
    // static async refreshCurrentSession() {
    //     const session = await Auth.currentSession();
    //     return this.refreshSessionPromise(session.getRefreshToken());
    // }

    // static async updateUserProfileData(name, userProfileData) {
    //     if (name === undefined || name.trim() === '') {
    //         throw new Error('Name is empty');
    //     }
    //     let appContext = new AppContext();
    //     await Auth.updateUserAttributes(await Auth.currentAuthenticatedUser(), {
    //         name: name,
    //         'custom:profile': JSON.stringify(userProfileData),
    //     });

    //     appContext.setUserProfileData(userProfileData);
    // }

    static setSession = async (session, history) => {
        let appContext = new AppContext();
        if (session) {
            if (session.idToken.payload['custom:profile'] !== undefined) {
                try {
                    appContext.setUserProfileData(JSON.parse(session.idToken.payload['custom:profile']));
                } catch (err) {}
            }

            const token = session.getIdToken().getJwtToken();
            let _StoreControllerNoPlatform = new StoreController('', '');
            _StoreControllerNoPlatform.set('isUserInit', true);
            await appContext.setToken(token, false, session.isValid(), false);
            await AppController.loadPlatformAndUserData();

            if (history) {
                // console.log('hola', session)
                let appContext = new AppContext();
                let storeController = new StoreController(appContext.getPlatformId(), '');
                let federatedRedirect = storeController.get('federatedRedirect');
                storeController.set('federatedRedirect', undefined);
                if (federatedRedirect !== undefined && federatedRedirect !== 'undefined') {
                    history.push(federatedRedirect);
                }
            }
        } else {
            await appContext.setToken(undefined, false, false, true);
        }
        appContext.notifyObservers('setSession');
    };
}

export default AuthController;
